import Vue from "vue";
import Vuex from "vuex";

import app from "src/vuex/modules/app";
import auth from "./modules/auth";
import exception from "./modules/exception";
import settings from "./modules/settings";
import orderFilter from "./modules/orderFilter";

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    auth,
    app,
    exception,
    settings,
    orderFilter,
  }
});
